import { languageIds } from './languageIds';

export const imperial = {
  in: {
    [languageIds.enUS]: 'in',
    [languageIds.esES]: 'pul',
    [languageIds.enGB]: 'in',
    [languageIds.frCA]: 'in',
    [languageIds.frFR]: 'in',
    [languageIds.deDE]: 'in',
  },
  ft: {
    [languageIds.enUS]: 'ft',
    [languageIds.esES]: 'p',
    [languageIds.enGB]: 'ft',
    [languageIds.frCA]: 'ft',
    [languageIds.frFR]: 'ft',
    [languageIds.deDE]: 'ft',
  },
  sf: {
    [languageIds.enUS]: 'sf',
    [languageIds.esES]: 'p\u00B2',
    [languageIds.enGB]: 'sf',
    [languageIds.frCA]: 'sf',
    [languageIds.frFR]: 'sf',
    [languageIds.deDE]: 'sf',
  },
  sy: {
    [languageIds.enUS]: 'sy',
    [languageIds.esES]: 'y\u00B3',
    [languageIds.enGB]: 'cy',
    [languageIds.frCA]: 'verges carrés',
    [languageIds.frFR]: 'verges carrés',
    [languageIds.deDE]: 'kubikmeter',
  },
  cf: {
    [languageIds.enUS]: 'cf',
    [languageIds.esES]: 'p\u00B3',
    [languageIds.enGB]: 'cf',
    [languageIds.frCA]: 'cf',
    [languageIds.frFR]: 'cf',
    [languageIds.deDE]: 'cf',
  },
  cfs: {
    [languageIds.enUS]: 'cfs',
    [languageIds.esES]: 'cfs',
    [languageIds.enGB]: 'cfs',
    [languageIds.frCA]: 'cfs',
    [languageIds.frFR]: 'cfs',
    [languageIds.deDE]: 'cfs',
  },
  cy: {
    [languageIds.enUS]: 'cy',
    [languageIds.esES]: 'y\u00B3',
    [languageIds.enGB]: 'cy',
    [languageIds.frCA]: 'verge cube',
    [languageIds.frFR]: 'verge cube',
    [languageIds.deDE]: 'kubikmeter',
  },
  inches: {
    [languageIds.enUS]: 'inches',
    [languageIds.esES]: 'pulgadas',
    [languageIds.enGB]: 'inches',
    [languageIds.frCA]: 'inches',
    [languageIds.frFR]: 'inches',
    [languageIds.deDE]: 'inches',
  },
  feet: {
    [languageIds.enUS]: 'feet',
    [languageIds.esES]: 'pies',
    [languageIds.enGB]: 'feet',
    [languageIds.frCA]: 'pieds',
    [languageIds.frFR]: 'pieds',
    [languageIds.deDE]: 'füße',
  },
  squareFeet: {
    [languageIds.enUS]: 'square ft',
    [languageIds.esES]: 'pies\u00B2',
    [languageIds.enGB]: 'square ft',
    [languageIds.frCA]: 'pieds carrés',
    [languageIds.frFR]: 'pieds carrés',
    [languageIds.deDE]: 'quadratfuß',
  },
  cubicFeet: {
    [languageIds.enUS]: 'cubic ft',
    [languageIds.esES]: 'pies\u00B3',
    [languageIds.enGB]: 'cubic ft',
    [languageIds.frCA]: 'pi cube',
    [languageIds.frFR]: 'pi cube',
    [languageIds.deDE]: 'kubikfuß',
  },
  cubicYard: {
    [languageIds.enUS]: 'cubic yards',
    [languageIds.esES]: 'yardas\u00B3',
    [languageIds.enGB]: 'cubic yards',
    [languageIds.frCA]: 'verges cubes',
    [languageIds.frFR]: 'verges cubes',
    [languageIds.deDE]: 'kubikmeter',
  },
  squareYard: {
    [languageIds.enUS]: 'square yards',
    [languageIds.esES]: 'yardas\u00B3',
    [languageIds.enGB]: 'cubic yards',
    [languageIds.frCA]: 'verges carrés',
    [languageIds.frFR]: 'verges carrés',
    [languageIds.deDE]: 'kubikmeter',
  },
};



// WEBPACK FOOTER //
// ./src/lib/localization/imperial.js